import { Field } from "csi/def/Field";
import Relationship from "csi/def/Relationship";
import FormWidget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import { TYPE_HIGG_CATEGORY } from "./HiggMaterialStore";

const HiggMaterialFormCustomize = declare(FormWidget, {

	/**
	 * @override
	 * Get higg categories
	 */
	getFieldStore(field: Field, value: string) {
		if (field.getControlName() === TYPE_HIGG_CATEGORY) {
			const rel = lang.mixin(new Relationship(), { m_typeNode: TYPE_HIGG_CATEGORY });
			const ctx = this.getContext();
			const store = ctx.view.createHeadingNamesStore(ctx, field, null, rel);

			return store;
		}

		return this.inherited(arguments);
	},
});

export = HiggMaterialFormCustomize;